function FormSelect({ label, name, id, content, value, setValue }) {
    return (
        <div>
            <label htmlFor={name} className='form-label'>{label}</label>
            <select name={name} id={id} required className='form-input' defaultValue={value} onChange={e => setValue(e.target.value)}>
                {value === "" && <option value={value} hidden>-- select option --</option>}
                {content && content?.map(item => (
                    <option key={item?.value} value={item?.value}>
                        {item.text}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default FormSelect